import React from 'react'
import { Card, Row, Col } from 'react-bootstrap';
import IntegrationProfile from './integrationProfile'
import GeneralProfile from './generalProfile'
import SubAccountProfile from './subAccountProfile'
import OnlineDDRegistration from './onlineDDRegistration'

export default function MerchantProfile({ className = "", onChange, onLogoChange, onLogoDelete, ...props }) {
  const { action, accessToken, integration, shadowAccountProfile, general, subAccountProfile, onlDDRegOpt, merchantAccountCurrencyList } = props;
  console.log(shadowAccountProfile);
  return (
    <Card className={className}>
      <Card.Header className="bg-white font-weight-bold text-scb">
        Merchant Profile
      </Card.Header>
      <Card.Body className="px-4" >
        <Row className="pt-2 pb-3">
          <Col className="border-right">
            <IntegrationProfile
              {...integration}
              action={action}
              accessToken={accessToken}
              shadowAccountProfile={shadowAccountProfile}
            />
          </Col>
          <Col>
            <GeneralProfile
              disabled={true}
              action={action}
              onLogoChange={onLogoChange} onLogoDelete={onLogoDelete}
              {...general} />
          </Col>
        </Row>
        <Row className="pt-2 pb-5">
          <Col>
            <SubAccountProfile
              subAccountProfile={subAccountProfile}
            />
          </Col>
        </Row>
        {integration.type === "API" ?
          <Row className="pt-2 pb-5 pl-3 pr-3">
            <Col className="pt-4" style={{ border: "3px solid #00000029" }} id="elementOnlDDRegOpt">
              <OnlineDDRegistration
                disabled={true}
                action={action}
                onlDDRegOpt={onlDDRegOpt}
                merchantAccountCurrencyList={merchantAccountCurrencyList}
              />
            </Col>
          </Row>
          : <></>
        }
      </Card.Body>
    </Card>
  )
}